<template>
  <div class="detail" :style="rulesShow ? style : ''">
    <!-- <back title="详情" /> -->
    <div class="container">
      <div class="info-a">
        <div class="title">{{ title }}</div>
        <p class="time" v-if="startTime">
          {{ startTime | format_Date }} {{ startTime | format_Date_a }}-{{ endTime | format_Date_a }}
        </p>
      </div>

      <div class="info-b">
        <span class="title">有效学习时间</span>
        <div class="rules" @click="rulesShow = true">有效时间规则</div>
      </div>

      <div class="info-c">
        <div class="left-c">
          <div class="time">
            <span class="num">{{ liveTime | format_current }}</span>
            <span class="text">分钟</span>
          </div>
          <div class="name">直播时间</div>
        </div>
        <div class="line-c"></div>
        <div class="right-c">
          <div class="time">
            <span class="num">{{ recordTime | format_current }}</span>
            <span class="text">分钟</span>
          </div>
          <div class="name">点播时间</div>
        </div>
      </div>

      <div class="info-d">
        <div class="info-d-item" v-for="(item, index) in lookRecord" :key="index">
          <img v-if="item.device_type == 1" src="../../assets/image/icon-pc.png" height="28" width="28" />
          <img v-if="item.device_type == 2" src="../../assets/image/icon-phone.png" height="28" width="28" />
          <span
            >{{ item.record_time | format_Date_c }} 观看了 {{ attrName(item.look_type, item.event_attr_name) }} “{{
              item.look_type === 2 ? (item.event_attr_name ? item.event_attr_name : item.event_name) : item.event_name
            }}” {{ item.study_time | format }}</span
          >
        </div>
      </div>
    </div>

    <div class="rules-mode" v-show="rulesShow">
      <div class="rules-mask"></div>
      <div class="rules-content">
        <i class="iconfont icon-close icon" @click="rulesShow = false"></i>
        <!-- <h3 class="title">有效学习时间规则</h3> -->
        <div>
          <p>1、直播或点播，观看20分钟以上记学时，低于20分钟不记学时。</p>
          <p>2、直播中途退出后再进入，观看时间继续累加。</p>
          <p>3、直播与点播分别记学时，发放学时二取一，以最高为准，不超过课程总学时。</p>
          <p>4、系统自动记录观看数据，不需在留言区回复"打卡"，"签到"等词语。</p>
          <p>5、观看直播或录播时长至少到课程总时长的一半才能申请证书。</p>
          <p>6、一堂课只能申请一次学时证书。</p>
          <p>7、只有观看本学科的课程，才能申请学时证书。</p>
          <p>8、如果对学时有异议，可先至"观看记录"页面查询，更多异议请联系工作人员。</p>
          <p>9、最后一次观看的24小时之后才能申请学时，申请后等待审核发放！</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Back from '@/components/back'
import {getDetailLookRecord, getUserStudyTimeByEvent} from '@/api/dd'
export default {
  name: 'detail',
  components: {
    // Back
  },
  data() {
    return {
      id: '',
      rulesShow: false,
      title: '',
      startTime: '',
      endTime: '',
      liveTime: '',
      recordTime: '',
      lookRecord: [],
      innerHeight: '',
      style: ''
    }
  },
  filters: {
    format(val) {
      if (val === null || val === undefined) {
        return ''
      } else if (val < 60) {
        return '＜1分钟'
      } else {
        return `${Math.floor(val / 60)}分钟`
      }
    },
    format_current(val) {
      return `${Math.floor(val / 60)}`
    }
  },
  watch: {
    rulesShow(newV) {
      if (newV) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    }
  },
  methods: {
    attrName(type, name) {
      if (type === 1) {
        return '直播'
      } else if (type === 2 && !name) {
        return '回放'
      } else if (type === 2 && name === 2) {
        return '视频'
      } else if (type === 2 && name === 6) {
        return '回放'
      }
    },
    initData() {
      getUserStudyTimeByEvent(this.$route.params.id).then(res => {
        if (res.code === 0 && res.success) {
          const data = res.data
          this.title = data.event_name
          this.startTime = data.event_start_time
          this.endTime = data.event_end_time
          this.liveTime = data.live_study_time
          this.recordTime = data.record_study_time
        }
      })
    },
    initList() {
      getDetailLookRecord(this.id).then(res => {
        if (res.code === 0 && res.success) {
          this.lookRecord = res.data
        }
      })
    }
  },
  created() {
    this.id = this.$route.params.id
    this.initData()
    this.initList()
  },
  mounted() {
    this.innerHeight = window.innerHeight
    this.style = {
      height: this.innerHeight - 10 + 'px',
      overflow: 'hidden'
    }
  }
}
</script>

<style lang="scss" scoped>
.detail {
  width: 100%;
  &.current {
    height: 700px;
    overflow: hidden;
  }
  .container {
    width: 100%;
    padding: 12px 16px;
    box-sizing: border-box;
    .info-a {
      width: 100%;
      padding: 20px 16px;
      box-sizing: border-box;
      background-color: #fff;
      border-radius: 12px;
      box-shadow: 0px 0px 12px 0px rgba(23, 38, 71, 0.1);
      .title {
        font-size: 16px;
        font-weight: 700;
        color: #303133;
        line-height: 28px;
      }
      .time {
        margin-top: 16px;
        color: #909399;
      }
    }
    .info-b {
      margin-top: 25px;
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 15px;
        font-weight: 700;
        color: #000000;
      }
      .rules {
        width: 100px;
        height: 28px;
        color: #fda423;
        border: 1px solid #fda423;
        border-radius: 14px;
        text-align: center;
        line-height: 28px;
        font-size: 13px;
      }
    }
    .info-c {
      margin-top: 16px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      padding: 16px 0;
      box-sizing: border-box;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0px 0px 12px 0px rgba(23, 38, 71, 0.1);
      .left-c,
      .right-c {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .time {
          .num {
            font-size: 30px;
            font-weight: 700;
            color: #4670f4;
          }
          .text {
            font-size: 13px;
            color: #4670f4;
          }
        }
        .name {
          font-size: 13px;
          color: #909399;
        }
      }
      .line-c {
        width: 1px;
        height: 36px;
        background: #e7e9ef;
      }
    }
    .info-d {
      margin-top: 28px;
      .info-d-item {
        display: flex;
        flex-direction: row;
        margin-bottom: 24px;
        span {
          margin-left: 10px;
          color: #606266;
          line-height: 28px;
        }
      }
    }
  }
  .rules-mode {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    .rules-mask {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: rgba(0, 5, 26, 0.4);
      z-index: 100;
    }
    .rules-content {
      position: absolute;
      left: 10%;
      top: 50%;
      transform: translateY(-50%);
      width: 80%;
      padding: 36px 30px;
      box-sizing: border-box;
      background-color: #ffffff;
      border-radius: 12px;
      z-index: 101;
      .icon {
        position: absolute;
        right: 12px;
        top: 12px;
      }
      .title {
        margin-bottom: 16px;
        font-size: 18px;
        font-weight: 700;
        color: #303133;
        text-align: center;
      }
      p {
        margin-bottom: 12px;
        color: #303133;
        font-size: 14px;
        line-height: 22px;
      }
    }
  }
}
</style>
